import { AuthResponseStatus } from '@/enums/AuthResponseStatus';
import Response from '@/models/Response';
import UserInfo from '@/models/UserInfo';

export default class UserInfoResponse extends Response {
  public userinfo: UserInfo = new UserInfo();

  constructor(
    status: AuthResponseStatus,
    userinfo: UserInfo,
    accessToken: string,
    refreshToken: string,
    messageEN = '',
    messageNL = ''
  ) {
    super(status, accessToken, refreshToken, messageEN, messageNL);
    this.userinfo = userinfo;
  }

  public static buildSuccesResponse(
    userinfo: UserInfo,
    accessToken: string,
    messageEN: string,
    messageNL: string
  ): UserInfoResponse {
    return new UserInfoResponse(AuthResponseStatus.SUCCESS, userinfo, accessToken, messageEN, messageNL);
  }

  public static buildFailedResponse(messageEN: string, messageNL: string): UserInfoResponse {
    return new UserInfoResponse(AuthResponseStatus.FAILED, new UserInfo(), '', '', messageEN, messageNL);
  }
}
